"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.PlayCircle = exports.PlaybackSpeed = exports.Play = exports.PIP2 = exports.PIP = exports.PauseCircle = exports.Pause = exports.Panorama = exports.Muted = exports.MusicNoteSlider2 = exports.MusicNoteSlider = exports.MusicNotes = exports.MusicNote4 = exports.MusicNote3 = exports.MusicNote2 = exports.MusicNote = exports.MusicLibrary2 = exports.MusicLibrary = exports.MicrophoneLarge = exports.Microphone3 = exports.Microphone2 = exports.Microphone = exports.Library = exports.GalleryWide = exports.GallerySend = exports.GalleryRound = exports.GalleryRemove = exports.GalleryMinimalistic = exports.GalleryFavourite = exports.GalleryEdit = exports.GalleryDownload = exports.GalleryCircle = exports.GalleryCheck = exports.GalleryAdd = exports.Gallery = exports.FullScreenSquare = exports.FullScreenCircle = exports.FullScreen = exports.ClapperboardText = exports.ClapperboardPlay = exports.ClapperboardOpenPlay = exports.ClapperboardOpen = exports.ClapperboardEdit = exports.Clapperboard = exports.CameraSquare = exports.CameraRotate = exports.CameraMinimalistic = exports.CameraAdd = exports.Camera = exports.Album = void 0;
exports.VolumeCross = exports.Volume = exports.VinylRecord = exports.Vinyl = exports.VideoLibrary = exports.VideoFrameReplace = exports.VideoFramePlayVertical = exports.VideoFramePlayHorizontal = exports.VideoFrameCut2 = exports.VideoFrameCut = exports.VideoFrame2 = exports.VideoFrame = exports.VideocameraRecord = exports.VideocameraAdd = exports.Videocamera = exports.UploadTrack2 = exports.UploadTrack = exports.ToPip = exports.Stream = exports.StopCircle = exports.Stop = exports.SoundwaveSquare = exports.SoundwaveCircle = exports.Soundwave = exports.SkipPrevious = exports.SkipNext = exports.Shuffle = exports.RewindForwardCircle = exports.RewindForward = exports.RewindBackCircle = exports.RewindBack = exports.Rewind5SecondsForward = exports.Rewind5SecondsBack = exports.Rewind15SecondsForward = exports.Rewind15SecondsBack = exports.Rewind10SecondsForward = exports.Rewind10SecondsBack = exports.RepeatOneMinimalistic = exports.RepeatOne = exports.Repeat = exports.Reel2 = exports.Reel = exports.RecordCircle = exports.Record = exports.QuitPip = exports.QuitFullScreenSquare = exports.QuitFullScreenCircle = exports.QuitFullScreen = exports.Podcast = exports.PlayStream = void 0;
exports.Wallpaper = exports.VolumeSmall = exports.VolumeLoud = void 0;
var Album_1 = require("./Album");
__createBinding(exports, Album_1, "default", "Album");
var Camera_1 = require("./Camera");
__createBinding(exports, Camera_1, "default", "Camera");
var CameraAdd_1 = require("./CameraAdd");
__createBinding(exports, CameraAdd_1, "default", "CameraAdd");
var CameraMinimalistic_1 = require("./CameraMinimalistic");
__createBinding(exports, CameraMinimalistic_1, "default", "CameraMinimalistic");
var CameraRotate_1 = require("./CameraRotate");
__createBinding(exports, CameraRotate_1, "default", "CameraRotate");
var CameraSquare_1 = require("./CameraSquare");
__createBinding(exports, CameraSquare_1, "default", "CameraSquare");
var Clapperboard_1 = require("./Clapperboard");
__createBinding(exports, Clapperboard_1, "default", "Clapperboard");
var ClapperboardEdit_1 = require("./ClapperboardEdit");
__createBinding(exports, ClapperboardEdit_1, "default", "ClapperboardEdit");
var ClapperboardOpen_1 = require("./ClapperboardOpen");
__createBinding(exports, ClapperboardOpen_1, "default", "ClapperboardOpen");
var ClapperboardOpenPlay_1 = require("./ClapperboardOpenPlay");
__createBinding(exports, ClapperboardOpenPlay_1, "default", "ClapperboardOpenPlay");
var ClapperboardPlay_1 = require("./ClapperboardPlay");
__createBinding(exports, ClapperboardPlay_1, "default", "ClapperboardPlay");
var ClapperboardText_1 = require("./ClapperboardText");
__createBinding(exports, ClapperboardText_1, "default", "ClapperboardText");
var FullScreen_1 = require("./FullScreen");
__createBinding(exports, FullScreen_1, "default", "FullScreen");
var FullScreenCircle_1 = require("./FullScreenCircle");
__createBinding(exports, FullScreenCircle_1, "default", "FullScreenCircle");
var FullScreenSquare_1 = require("./FullScreenSquare");
__createBinding(exports, FullScreenSquare_1, "default", "FullScreenSquare");
var Gallery_1 = require("./Gallery");
__createBinding(exports, Gallery_1, "default", "Gallery");
var GalleryAdd_1 = require("./GalleryAdd");
__createBinding(exports, GalleryAdd_1, "default", "GalleryAdd");
var GalleryCheck_1 = require("./GalleryCheck");
__createBinding(exports, GalleryCheck_1, "default", "GalleryCheck");
var GalleryCircle_1 = require("./GalleryCircle");
__createBinding(exports, GalleryCircle_1, "default", "GalleryCircle");
var GalleryDownload_1 = require("./GalleryDownload");
__createBinding(exports, GalleryDownload_1, "default", "GalleryDownload");
var GalleryEdit_1 = require("./GalleryEdit");
__createBinding(exports, GalleryEdit_1, "default", "GalleryEdit");
var GalleryFavourite_1 = require("./GalleryFavourite");
__createBinding(exports, GalleryFavourite_1, "default", "GalleryFavourite");
var GalleryMinimalistic_1 = require("./GalleryMinimalistic");
__createBinding(exports, GalleryMinimalistic_1, "default", "GalleryMinimalistic");
var GalleryRemove_1 = require("./GalleryRemove");
__createBinding(exports, GalleryRemove_1, "default", "GalleryRemove");
var GalleryRound_1 = require("./GalleryRound");
__createBinding(exports, GalleryRound_1, "default", "GalleryRound");
var GallerySend_1 = require("./GallerySend");
__createBinding(exports, GallerySend_1, "default", "GallerySend");
var GalleryWide_1 = require("./GalleryWide");
__createBinding(exports, GalleryWide_1, "default", "GalleryWide");
var Library_1 = require("./Library");
__createBinding(exports, Library_1, "default", "Library");
var Microphone_1 = require("./Microphone");
__createBinding(exports, Microphone_1, "default", "Microphone");
var Microphone2_1 = require("./Microphone2");
__createBinding(exports, Microphone2_1, "default", "Microphone2");
var Microphone3_1 = require("./Microphone3");
__createBinding(exports, Microphone3_1, "default", "Microphone3");
var MicrophoneLarge_1 = require("./MicrophoneLarge");
__createBinding(exports, MicrophoneLarge_1, "default", "MicrophoneLarge");
var MusicLibrary_1 = require("./MusicLibrary");
__createBinding(exports, MusicLibrary_1, "default", "MusicLibrary");
var MusicLibrary2_1 = require("./MusicLibrary2");
__createBinding(exports, MusicLibrary2_1, "default", "MusicLibrary2");
var MusicNote_1 = require("./MusicNote");
__createBinding(exports, MusicNote_1, "default", "MusicNote");
var MusicNote2_1 = require("./MusicNote2");
__createBinding(exports, MusicNote2_1, "default", "MusicNote2");
var MusicNote3_1 = require("./MusicNote3");
__createBinding(exports, MusicNote3_1, "default", "MusicNote3");
var MusicNote4_1 = require("./MusicNote4");
__createBinding(exports, MusicNote4_1, "default", "MusicNote4");
var MusicNotes_1 = require("./MusicNotes");
__createBinding(exports, MusicNotes_1, "default", "MusicNotes");
var MusicNoteSlider_1 = require("./MusicNoteSlider");
__createBinding(exports, MusicNoteSlider_1, "default", "MusicNoteSlider");
var MusicNoteSlider2_1 = require("./MusicNoteSlider2");
__createBinding(exports, MusicNoteSlider2_1, "default", "MusicNoteSlider2");
var Muted_1 = require("./Muted");
__createBinding(exports, Muted_1, "default", "Muted");
var Panorama_1 = require("./Panorama");
__createBinding(exports, Panorama_1, "default", "Panorama");
var Pause_1 = require("./Pause");
__createBinding(exports, Pause_1, "default", "Pause");
var PauseCircle_1 = require("./PauseCircle");
__createBinding(exports, PauseCircle_1, "default", "PauseCircle");
var PIP_1 = require("./PIP");
__createBinding(exports, PIP_1, "default", "PIP");
var PIP2_1 = require("./PIP2");
__createBinding(exports, PIP2_1, "default", "PIP2");
var Play_1 = require("./Play");
__createBinding(exports, Play_1, "default", "Play");
var PlaybackSpeed_1 = require("./PlaybackSpeed");
__createBinding(exports, PlaybackSpeed_1, "default", "PlaybackSpeed");
var PlayCircle_1 = require("./PlayCircle");
__createBinding(exports, PlayCircle_1, "default", "PlayCircle");
var PlayStream_1 = require("./PlayStream");
__createBinding(exports, PlayStream_1, "default", "PlayStream");
var Podcast_1 = require("./Podcast");
__createBinding(exports, Podcast_1, "default", "Podcast");
var QuitFullScreen_1 = require("./QuitFullScreen");
__createBinding(exports, QuitFullScreen_1, "default", "QuitFullScreen");
var QuitFullScreenCircle_1 = require("./QuitFullScreenCircle");
__createBinding(exports, QuitFullScreenCircle_1, "default", "QuitFullScreenCircle");
var QuitFullScreenSquare_1 = require("./QuitFullScreenSquare");
__createBinding(exports, QuitFullScreenSquare_1, "default", "QuitFullScreenSquare");
var QuitPip_1 = require("./QuitPip");
__createBinding(exports, QuitPip_1, "default", "QuitPip");
var Record_1 = require("./Record");
__createBinding(exports, Record_1, "default", "Record");
var RecordCircle_1 = require("./RecordCircle");
__createBinding(exports, RecordCircle_1, "default", "RecordCircle");
var Reel_1 = require("./Reel");
__createBinding(exports, Reel_1, "default", "Reel");
var Reel2_1 = require("./Reel2");
__createBinding(exports, Reel2_1, "default", "Reel2");
var Repeat_1 = require("./Repeat");
__createBinding(exports, Repeat_1, "default", "Repeat");
var RepeatOne_1 = require("./RepeatOne");
__createBinding(exports, RepeatOne_1, "default", "RepeatOne");
var RepeatOneMinimalistic_1 = require("./RepeatOneMinimalistic");
__createBinding(exports, RepeatOneMinimalistic_1, "default", "RepeatOneMinimalistic");
var Rewind10SecondsBack_1 = require("./Rewind10SecondsBack");
__createBinding(exports, Rewind10SecondsBack_1, "default", "Rewind10SecondsBack");
var Rewind10SecondsForward_1 = require("./Rewind10SecondsForward");
__createBinding(exports, Rewind10SecondsForward_1, "default", "Rewind10SecondsForward");
var Rewind15SecondsBack_1 = require("./Rewind15SecondsBack");
__createBinding(exports, Rewind15SecondsBack_1, "default", "Rewind15SecondsBack");
var Rewind15SecondsForward_1 = require("./Rewind15SecondsForward");
__createBinding(exports, Rewind15SecondsForward_1, "default", "Rewind15SecondsForward");
var Rewind5SecondsBack_1 = require("./Rewind5SecondsBack");
__createBinding(exports, Rewind5SecondsBack_1, "default", "Rewind5SecondsBack");
var Rewind5SecondsForward_1 = require("./Rewind5SecondsForward");
__createBinding(exports, Rewind5SecondsForward_1, "default", "Rewind5SecondsForward");
var RewindBack_1 = require("./RewindBack");
__createBinding(exports, RewindBack_1, "default", "RewindBack");
var RewindBackCircle_1 = require("./RewindBackCircle");
__createBinding(exports, RewindBackCircle_1, "default", "RewindBackCircle");
var RewindForward_1 = require("./RewindForward");
__createBinding(exports, RewindForward_1, "default", "RewindForward");
var RewindForwardCircle_1 = require("./RewindForwardCircle");
__createBinding(exports, RewindForwardCircle_1, "default", "RewindForwardCircle");
var Shuffle_1 = require("./Shuffle");
__createBinding(exports, Shuffle_1, "default", "Shuffle");
var SkipNext_1 = require("./SkipNext");
__createBinding(exports, SkipNext_1, "default", "SkipNext");
var SkipPrevious_1 = require("./SkipPrevious");
__createBinding(exports, SkipPrevious_1, "default", "SkipPrevious");
var Soundwave_1 = require("./Soundwave");
__createBinding(exports, Soundwave_1, "default", "Soundwave");
var SoundwaveCircle_1 = require("./SoundwaveCircle");
__createBinding(exports, SoundwaveCircle_1, "default", "SoundwaveCircle");
var SoundwaveSquare_1 = require("./SoundwaveSquare");
__createBinding(exports, SoundwaveSquare_1, "default", "SoundwaveSquare");
var Stop_1 = require("./Stop");
__createBinding(exports, Stop_1, "default", "Stop");
var StopCircle_1 = require("./StopCircle");
__createBinding(exports, StopCircle_1, "default", "StopCircle");
var Stream_1 = require("./Stream");
__createBinding(exports, Stream_1, "default", "Stream");
var ToPip_1 = require("./ToPip");
__createBinding(exports, ToPip_1, "default", "ToPip");
var UploadTrack_1 = require("./UploadTrack");
__createBinding(exports, UploadTrack_1, "default", "UploadTrack");
var UploadTrack2_1 = require("./UploadTrack2");
__createBinding(exports, UploadTrack2_1, "default", "UploadTrack2");
var Videocamera_1 = require("./Videocamera");
__createBinding(exports, Videocamera_1, "default", "Videocamera");
var VideocameraAdd_1 = require("./VideocameraAdd");
__createBinding(exports, VideocameraAdd_1, "default", "VideocameraAdd");
var VideocameraRecord_1 = require("./VideocameraRecord");
__createBinding(exports, VideocameraRecord_1, "default", "VideocameraRecord");
var VideoFrame_1 = require("./VideoFrame");
__createBinding(exports, VideoFrame_1, "default", "VideoFrame");
var VideoFrame2_1 = require("./VideoFrame2");
__createBinding(exports, VideoFrame2_1, "default", "VideoFrame2");
var VideoFrameCut_1 = require("./VideoFrameCut");
__createBinding(exports, VideoFrameCut_1, "default", "VideoFrameCut");
var VideoFrameCut2_1 = require("./VideoFrameCut2");
__createBinding(exports, VideoFrameCut2_1, "default", "VideoFrameCut2");
var VideoFramePlayHorizontal_1 = require("./VideoFramePlayHorizontal");
__createBinding(exports, VideoFramePlayHorizontal_1, "default", "VideoFramePlayHorizontal");
var VideoFramePlayVertical_1 = require("./VideoFramePlayVertical");
__createBinding(exports, VideoFramePlayVertical_1, "default", "VideoFramePlayVertical");
var VideoFrameReplace_1 = require("./VideoFrameReplace");
__createBinding(exports, VideoFrameReplace_1, "default", "VideoFrameReplace");
var VideoLibrary_1 = require("./VideoLibrary");
__createBinding(exports, VideoLibrary_1, "default", "VideoLibrary");
var Vinyl_1 = require("./Vinyl");
__createBinding(exports, Vinyl_1, "default", "Vinyl");
var VinylRecord_1 = require("./VinylRecord");
__createBinding(exports, VinylRecord_1, "default", "VinylRecord");
var Volume_1 = require("./Volume");
__createBinding(exports, Volume_1, "default", "Volume");
var VolumeCross_1 = require("./VolumeCross");
__createBinding(exports, VolumeCross_1, "default", "VolumeCross");
var VolumeLoud_1 = require("./VolumeLoud");
__createBinding(exports, VolumeLoud_1, "default", "VolumeLoud");
var VolumeSmall_1 = require("./VolumeSmall");
__createBinding(exports, VolumeSmall_1, "default", "VolumeSmall");
var Wallpaper_1 = require("./Wallpaper");
__createBinding(exports, Wallpaper_1, "default", "Wallpaper");
